import { createApiRef } from '@backstage/core-plugin-api';

export const pdpLoggerApiRef = createApiRef<PdpLoggerApi>({
  id: 'plugin.pdp-logger.service',
});

export interface PdpLoggerApi {
  log(
    level: 'info' | 'warn' | 'error',
    message: string,
    meta?: Record<string, any>,
  ): Promise<void>;
}
